<template>
  <div class="page">
    <side-icons />
    <section class="section no-padding-bottom">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Teaching</h3></div>
      <el-row class="flex flex-wrap flex-stretch" :gutter="20">
        <el-col v-for="item in teachingPageList" :key="item.id" class="margin-bottom-20px" :xs="24" :sm="12" :md="8">
          <el-card shadow="hover">
            <p class="fs-20 bold">{{ item.course }}</p>
            <p class="margin-top-10px text">
              <i class="el-icon-date" />
              <span class="margin-left-5px">{{ item.time }}</span>
            </p>
            <p class="margin-top-10px">
              <i class="iconfont icon-dingwei" />
              <span class="margin-left-5px">{{ item.school }}</span>
              <span v-if="item.with">, {{ item.with }}</span>
            </p>
          </el-card>
        </el-col>
      </el-row>
      <!-- 分页 -->
      <div class="pagination margin-top-20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="pageSize"
          :total="total"
          @current-change="pageChange"
        />
      </div>
    </section>
    <section class="section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Postdocs</h3></div>
      <el-row class="flex flex-wrap flex-stretch" :gutter="20">
        <el-col v-for="item in postdocList" :key="item.id" class="margin-bottom-20px" :xs="24" :sm="12" :md="8">
          <el-card shadow="hover">
            <p class="fs-20 bold">{{ item.name }}</p>
            <p class="margin-top-10px text">
              <i class="el-icon-date" />
              <span class="margin-left-5px">{{ item.duration }}</span>
            </p>
            <p v-if="item.current" class="margin-top-10px">{{ item.current }}</p>
          </el-card>
        </el-col>
      </el-row>
    </section>
  </div>
</template>
<script type="text/javascript">
import SideIcons from '@/components/sideIcons/sideIcons'
import jsData from '@/data/teaching.js'
import topMixin from '@/components/sideIcons/topMixin'
export default {
  components: { SideIcons },
  mixins: [topMixin],
  data() {
    return {
      page: 1,
      pageSize: 9,
      teachingPageList: []
    }
  },
  computed: {
    total() {
      return this.teachingList.length
    },
    teachingList() {
      return jsData.teaching.map((item, index) => {
        const arr = item.split(',')
        return {
          id: index,
          time: arr[0],
          course: arr[1],
          school: arr[2],
          with: arr[3] || ''
        }
      })
    },
    postdocList() {
      return jsData.postdocs
    }
  },
  created() {
    this.teachingPageList = this.teachingList.slice(0, this.pageSize)
  },
  methods: {
    pageChange(val) {
      this.page = val
      this.teachingPageList = this.teachingList.slice((val - 1) * this.pageSize, val * this.pageSize)
      this.toTop()
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  .section{
    padding-left: 10%;
    padding-right: 10%;
    .section-title{
      margin-bottom: 30px;
    }
    li{
      margin-bottom: 10px;
    }
  }
  .el-card{
    height: 100%;
  }
  .avatar{
    width: 250px;
    height: 320px;
    min-width: 250px;
    border-radius: 20px;
    margin-right: 50px;
  }
}
</style>
